import React from 'react'
import { Modal } from '@musinsa/mwms-ds'
import { useMWPShipperUpdateForm } from './hooks/useMWPShipperForm'
import { useMLTShipperUpdateForm } from './hooks/useMLTShipperForm'
import { useMCDShipperUpdateForm } from './hooks/useMCDShipperForm'
import MWPShipperFormComponent from './forms/MWPShipperForm'
import MLTShipperFormComponent from './forms/MLTShipperForm'
import MCDShipperFormComponent from './forms/MCDShipperForm'
import MFSShipperFormComponent from './forms/MFSShipperForm'
import { ShipperItem } from '@/services/shipper/types'
import { useMFSShipperUpdateForm } from './hooks/useMFSShipperForm'

interface Props {
  open: boolean
  shipperData: ShipperItem
  onClose: () => void
  onRefresh: () => Promise<void>
}

type ShipperType = 'MWP' | 'MLT' | 'MCD' | 'MFS'

function ShipperUpdateModal({ open, shipperData, onClose, onRefresh }: Props) {
  const shipperType = shipperData.logisticsServiceType as ShipperType

  const mwpShipper = useMWPShipperUpdateForm(shipperData, onRefresh, onClose)
  const mltShipper = useMLTShipperUpdateForm(shipperData, onRefresh, onClose)
  const mcdShipper = useMCDShipperUpdateForm(shipperData, onRefresh, onClose)
  const mfsShipper = useMFSShipperUpdateForm(shipperData, onRefresh, onClose)

  const getCurrentShipper = () => {
    switch (shipperType) {
      case 'MWP':
        return mwpShipper
      case 'MLT':
        return mltShipper
      case 'MCD':
        return mcdShipper
      case 'MFS':
        return mfsShipper
      default:
        return mwpShipper
    }
  }

  const currentShipper = getCurrentShipper()

  const renderForm = () => {
    switch (shipperType) {
      case 'MWP':
        return <MWPShipperFormComponent type="update" form={mwpShipper.form as any} />
      case 'MLT':
        return <MLTShipperFormComponent type="update" form={mltShipper.form as any} />
      case 'MCD':
        return <MCDShipperFormComponent type="update" form={mcdShipper.form as any} />
      case 'MFS':
        return <MFSShipperFormComponent form={mfsShipper.form as any} />
      default:
        return null
    }
  }

  if (!open) return null

  return (
    <Modal
      open
      size="md"
      title={`${shipperType} 화주사 수정`}
      buttons={[
        { kind: 'secondary', content: '취소', onClick: onClose },
        {
          kind: 'primary_light',
          content: '저장',
          onClick: currentShipper.handleSubmit,
          disabled: !currentShipper.isValid,
        },
      ]}
      onClose={onClose}
    >
      {renderForm()}
    </Modal>
  )
}

export default ShipperUpdateModal
